import React from "react";

/**
 * @component ArrowCollapseMultipleIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ArrowCollapseMultipleIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ArrowCollapseMultipleIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ArrowCollapseMultipleIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M12 15l4.72 4.461a.867.867 0 010 1.275.995.995 0 01-1.25.08l-.098-.08L12 17.549l-3.372 3.187a.993.993 0 01-1.349 0 .865.865 0 01-.079-1.19l.08-.085L12 15zm4.72-11.736a.867.867 0 010 1.275L12 9 7.28 4.539a.867.867 0 010-1.275.993.993 0 011.348 0L12 6.451l3.372-3.187a.993.993 0 011.349 0zM6 11h12a1 1 0 010 2H6a1 1 0 010-2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
ArrowCollapseMultipleIcon.displayName = "ArrowCollapseMultipleIcon";
export default ArrowCollapseMultipleIcon;
